export default __webpack_public_path__ + "static/media/green_ok.0d1dfc70.svg";